export const faqData = {
  mainLine: "(888) 705-5274",
  contactInformation: [
    {
      contactId: 1,
      department: "Credentialing",
      email: "credentialing@tangocare.com",
      fax: "",
    },
    {
      contactId: 2,
      department: "Provider Relations",
      email: "providernetwork@tangocare.com",
      fax: "(877) 327-1530",
    },
    {
      contactId: 3,
      department: "Contract Management",
      email: "ContractManagement@tangocare.com",
      fax: "",
    },
    {
      contactId: 4,
      department: "Referrals/prior-authorizations",
      email: "fax@tangocare.com",
      fax: "(877) 612-7066",
    },
    {
      contactId: 5,
      department: "Re-authorizations",
      email: "CMFax@tangocare.com",
      fax: "(877) 225-9710",
    },
    {
      contactId: 6,
      department: "Claims issues/questions",
      email: "claims@tangocare.com",
      fax: "(602) 995-3030",
    },
  ],
  questionData: [
    {
      question: "How to Clear Your Cache and Cookies?",
      answer: `
        <details>
          <summary><b>GOOGLE CHROME</b></summary>
          <ol>
            <li>Launch your Chrome browser.</li>
            <li>Click on the 3 vertical dots (<b>⁝</b>) on your browser toolbar and go to <b>"Settings"</b>.</li>
            <li>On the left pane, select <b>"Privacy and Security"</b>.</li>
            <li>In the privacy and security area, click on <b>"Clear browsing data"</b>.</li>
            <li>In the <b>"Clear browsing data"</b> box, change the <b>"Time range"</b> drop-down to <b>All time</b>.</li>
            <li>Make sure the basic tab is highlighted, and the 3 boxes are checked.</li>
            <li>Click <b>"Clear data"</b>.</li>
            <li>Restart your Chrome browser.</li>
          </ol>
          <a href="https://support.google.com/accounts/answer/32050" target="_blank" rel="noopener">Official Chrome Support Page</a>
        </details><br/>
    
        <details>
          <summary><b>MICROSOFT EDGE</b></summary>
          <ol>
            <li>Launch your Edge browser.</li>
            <li>Click on the 3-lined <b>Hub</b> (<b>⋯</b>) button in the top right corner.</li>
            <li>Click on <b>Settings</b>.</li>
            <li>Go down to <b>Clear browsing data</b>.</li>
            <li>Click on <b>Choose what to clear</b>.</li>
            <li>You will see the following items available:
            <ul>
              <li>Browsing history.</li>
              <li>Cookies and saved website data.</li>
              <li>Cached data and files.</li>
              <li>Tabs I’ve set aside or recently closed.</li>
              <li>Download History.</li>
              <li>Form Data.</li>
              <li>Passwords.</li>
              <li>Media licenses.</li>
              <li>Website permissions.</li>
            </ul>
            </li>
            <li>Select the first four options listed above to clear and click on the <b>Clear</b> button</li>
            <li>Restart your Microsoft Edge browser.</li>
          </ol>
          <a href="https://support.microsoft.com/en-us/microsoft-edge/view-and-delete-browser-history-in-microsoft-edge-00cf7943-a9e1-975a-a33d-ac10ce454ca4" target="_blank" rel="noopener">Official Edge Support Page</a>
        </details><br/>
    
        <details>
          <summary><b>SAFARI</b></summary>
          <ol>
            <li><b>Cookies:</b> Click <b>Safari</b> on the upper left-hand side of your screen. In the menu that appears, click <b>Preferences</b>.</li>
            <li>In the window that appears, click the <b>Privacy</b> tab. Click the button <b>Manage Website Data</b>.</li>
            <li>Click <b>Remove Now</b> in the pop-up window that appears.</li>
            <li>Click <b>Safari</b> on the upper left-hand side of your screen. In the menu that appears, click <b>Preferences</b>.</li>
            <li><b>Cache:</b> In the Preferences window, click the <b>Advanced</b> tab and make sure the checkbox next to "Show Develop menu in menu bar" is selected.</li>
            <li>Select <b>Develop</b> in the menu bar on the top of the screen and click <b>Empty Caches</b>.</li>
            <li>Restart your Safari browser.</li>
          </ol>
          <a href="https://support.apple.com/en-in/guide/safari/sfri11471/18.0/mac" target="_blank" rel="noopener">Official Safari Support Page</a>
        </details><br/>
    
        <details>
          <summary><b>MOZILLA FIREFOX</b></summary>
          <ol>
            <li>Launch your Firefox browser.</li>
            <li>Click the menu button (the three vertical lines <b>≡</b>) and choose <b>Options</b>.</li>
            <li>Click on <b>Privacy & Security</b>.</li>
            <li>In the <b>Cookies and Site Data</b> section, click <b>Clear Data...</b>.</li>
            <li>Close the <i>about: preferences</i> page. Any changes you've made will automatically be saved.</li>
            <li>Restart your Firefox browser.</li>
          </ol>
          <a href="https://support.mozilla.org/en-US/kb/clear-cookies-and-site-data-firefox" target="_blank" rel="noopener">Official Firefox Support Page</a>
        </details>
      `,
    },
    {
      question: "What are tango’s hours of operation?",
      answer:
        "Monday - Friday 8:00am-6:00pm (MST) with Saturday and Sunday 8:30am-5:30pm (MST).",
    },
    {
      question:
        "Which health plans and product lines is tango contracted with?",
      answer: `See APPENDIX B - HEALTH PLAN INFORMATION within the <a href="/providerMaterial" rel="noopener">Home Health Agency Provider Manual</a>.`,
    },
    {
      question: "What services is tango contracted for with the health plans?",
      answer: "Skilled Home Health Services (SN, PT, OT, ST, MSW, HHA).",
    },
    {
      question: "What services require a referral or a prior authorization?",
      answer:
        "All Skilled Home Health Services require a referral and / or prior authorization.",
    },
    {
      question: "How do I get a referral or prior authorization?",
      answer: `Complete all form fields on the Initial Authorization Form, which can be found by <a href="/createPriorAuth" target="_blank" rel="noopener">clicking here</a>.<br/><br/>
              Once form fields are completed, drag and drop the referral into the upload area located at the bottom of the page (ONE referral per upload)<br/><br/>
              If multiple referrals are being loaded, the above process MUST be followed for each patient referral, otherwise your referrals may be lost in transmission.<br/><br/>
              If you have any questions regarding the upload process, please call tango at 888-705-5274 and speak with the reception or Intake Team.<br/><br/>
              Initial authorization is typically given in four (4) week increments. All re‐authorizations are typically given in two (2) week increments.`,
    },
    {
      question: "Is there an after hours/weekend or emergency contact?",
      answer: `Our regular business hours are Friday 8:00am-6:00pm (MST) with Saturday and Sunday 8:30am-5:30pm (MST).<br/>
               Our Intake and Review Department is also available on weekends and major holidays from 8:30am to 5:30pm (MST).<br/>
               Our staff is available to answer questions you may have. Contact our main number at 888-705-5274 and the receptionist will direct you to the correct department.`,
    },
    {
      question: "How do I know if I have a referral?",
      answer: `The preferred way to view referrals is to log into ProNet Connect. <a target='_blank' href='https://pronetconnect.com/'>https://pronetconnect.com/</a><br/>
               Go to the Referral Management tab and log into Dina to view your Inbox for referrals.<br/><br/>
               You will also receive an email notification from Dina when there is a referral in your Inbox. You can log directly into Dina directly to view your Inbox for referrals.<br/>
               <a target='_blank' href='https://app.dinacare.com/#/login'>https://app.dinacare.com/#/login</a><br/>
               You can download the Dina app to your phone to receive referral alerts.<br/>
               Dina Mobile App Google Play for Android:<br/>
               <a target='_blank' href='https://play.google.com/store/apps/details?id=com.dina.app'>https://play.google.com/store/apps/details?id=com.dina.app</a><br/>
               Dina Mobile App Store for iPhone<br/>
               <a target='_blank' href='https://apps.apple.com/us/app/dina/id1498309764'>https://apps.apple.com/us/app/dina/id1498309764</a>`,
    },
    {
      question: "Do I still accept my referrals in Dina?",
      answer: `Yes, you still accept referrals in Dina. You should select evaluate before reviewing the referral, then accept or decline the referral once reviewed.<br/><br/>
               If you accept the referral, provide the estimated start of care (SOC) date in the notes.<br/>
               If your agency is selected by tango to provide services, you will see the status change in DINA.<br/>
               The final step for the agency is to select Admitted or Not Admitted to close the referral. If admitted provide the SOC date.<br/><br/>
               Only select Admitted after you have physically seen the patient.`,
    },
    {
      question:
        "Why can’t tango provide visits for the whole certification period?",
      answer:
        "tango must review all services; the frequency of the review is up to the Nurse who reviews the request. The Nurse and/or Medical Director must make sure that Medical Necessity is met.",
    },
    {
      question: "What is the purpose of Home Therapy?",
      answer:
        "The purpose of Home Therapy is to teach and train a home exercise program and to advance the patient to an Outpatient facility if needed.",
    },
    {
      question: "Is Transportation offered?",
      answer:
        "Transportation to the MD offices is coordinated by the PCP if the Health Plan offers that service.",
    },
    {
      question:
        "How long does it take the Health Plan to make a determination if the case has to be escalated for determination?",
      answer:
        "For Medicare Expedited requests the Health Plan has 72 hours to make a determination and 14 days for routine requests. For Medicaid Expedited requests the Health Plan has 48 hours to make a determination and 7 days for Routine requests.",
    },
    {
      question: "What happens if a patient’s insurance terminates during care?",
      answer:
        "The Provider must check eligibility every month and also ask the patient if he or she has changed Health Plans. Should this occur, the Provider must contact the new Health Plan and ask for an authorization. The services should be reimbursed by the new Health Plan as a Continuity of Care.",
    },
    {
      question: "What happens when a Physician will not sign the Plan of Care?",
      answer:
        "The Provider must call tango and speak to a Representative from Home Health and they will get the Health Plan involved to assist in getting the POC signed.",
    },
    {
      question: "Can verbal orders be signed by an LPN?",
      answer:
        "Written Verbal Orders from a MD / DO / DPM / NP / PA can be taken by an LPN.",
    },
    {
      question: "Can a follow up request for Home Health be faxed to tango?",
      answer: "No, all Concurrent requests must be submitted via the Portal.",
    },
    {
      question: "Can I call tango to ask questions regarding Home Health?",
      answer:
        "Yes, we welcome calls to the Utilization Management Department with your questions; see the contact list for names and extensions.",
    },
    {
      question:
        "Can I obtain orders from the MD offices directly, start care, then obtain the auth after?",
      answer:
        "No, orders must be faxed to tango and the auth needs to be issued prior to item(s) being delivered.",
    },
    {
      question: "Can I verify eligibility on the tango Provider Portal?",
      answer:
        "No, eligibility must be checked via the individual plan website or by calling our main line at 888-705-5274 and speaking with Eligibility Department.",
    },
    {
      question:
        " What should I do if an Agency NTU was incorrectly reported via the provider portal?",
      answer:
        "Send a secure email to DataEntry@tangocare.com with the patient details and SOC date completed.",
    },
    {
      question:
        "What are considered routine supplies when performing home health services?",
      answer:
        " Routine Home Health Medical Supplies include, but are not limited to routine supplies that are provided in conjunction with a nursing visit and may be used for multiple patients at the time of the visit which may consist of the following: Gauze pads, tape, Band-Aids, gloves, face masks, alcohol, alcohol pad/wipes, cotton balls/swabs, lubricant jelly, thermometers, lab draw supplies, needles, syringes, gowns, aprons, absorbent sterile dressings (ABD), Kerlix, sharps containers, sterile specimen containers, disposable instrument sets, suture removal sets, normal saline for dressing and irrigation, betadine wipes, peroxide, vacutainers.",
    },
    {
      question: "What are not considered routine Home Health Medical Supplies?",
      answer:
        "Non-Routine Supplies, which are patient specific supplies such as catheters, ostomy device, gastrostomy tubes, silver dressings. NSR, if covered, will be provided by Company’s medical supply provider or durable medical equipment provider.",
    },
    {
      question:
        "What are the most commonly used Case Management abbreviations?",
      answer: `To view a copy of the commonly used abbreviations, please follow this <a href="/abbrevations.pdf" target="_blank" rel="noopener">link</a>.`,
    },
  ],
};

export const ContactInfoHeaderLabel = ["Department", "Email", "Fax"];

export enum GetFrequentlyAskedQuestionActionDispatchTypes {
  GET_FREQUENTLY_ASKED_QUESTION_SUCCESS = "GET_FREQUENTLY_ASKED_QUESTION_SUCCESS",
  GET_FREQUENTLY_ASKED_QUESTION_INVOKE = "GET_FREQUENTLY_ASKED_QUESTION_INVOKE",
}
